import { render } from "./Prayer.vue?vue&type=template&id=32c3fa36"
import script from "./Prayer.vue?vue&type=script&lang=js"
export * from "./Prayer.vue?vue&type=script&lang=js"
script.render = render

export default script